import React, { useState, useEffect, useCallback } from 'react'
import styled from '@emotion/styled'

import UsersService from 'Services/users'

import { Trash2 } from 'react-feather'
import Table, { TableRow, TableCell } from 'Components/Table'
import { colors } from 'Constants'

import { navigate } from 'raviger'
import { toast } from 'react-toastify'
import VirtualOfficesService from 'Services/virtual-offices'
import { toastWithErrorMessage } from 'Helpers/toast'

const TableRowClickableStyle = styled(TableRow)`
  cursor: pointer;
  > * {
    transition: 0.2s background-color;
  }

  :hover {
    > * {
      background-color: ${colors.background900};
    }
  }
`

const TableRowClickable = ({ data, ...props }) => (
  <TableRowClickableStyle
    onClick={() => navigate(`/admin/users?id=${data.id}`)}
    data={data}
    {...props}
  />
)

const columns = [
  {
    header: 'Username',
    accessor: 'username'
  },
  {
    header: 'First Name',
    accessor: 'firstName'
  },
  {
    header: 'Last Name',
    accessor: 'lastName'
  },
  {
    header: 'Permission Level',
    accessor: 'permissionEnum',
    size: '0.5x'
  }
]

export default () => {
  const [users, setUsers] = useState([])

  useEffect(async () => {
    setUsers(await UsersService.list())
  }, [])

  return <Table columns={columns} data={users} Row={TableRowClickable} />
}

export const UserTableVirtualOffice = ({ virtualOffice, setVirtualOffice }) => {
  const DeleteCell = useCallback(
    ({ data }) => (
      <TableCell
        xAlign
        onClick={e => {
          e.stopPropagation()
          const selectedUser = virtualOffice.users.find(user => user.username === data.username)
          if (!selectedUser) return toast.error('Failed to find user to delete')

          VirtualOfficesService.removeUsers({
            virtualOfficeId: virtualOffice.id,
            users: [selectedUser.id]
          })
            .then(() => {
              virtualOffice.users.splice(virtualOffice.users.indexOf(selectedUser), 1)
              setVirtualOffice({ ...virtualOffice })
            })
            .catch(toastWithErrorMessage('Failed to remove user'))
        }}
      >
        <Trash2 />
      </TableCell>
    ),
    [virtualOffice]
  )

  const columnsWithDelete = [
    ...columns,
    { header: 'Delete', size: '0.2x', accessor: 'delete', Cell: DeleteCell }
  ]

  return <Table columns={columnsWithDelete} data={virtualOffice.users} Row={TableRowClickable} />
}
